// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Block wrapper so Shoreline Field (inline-flex) fills the parent instead of
   sizing to the hint/select intrinsic width via min-width:auto. */
.vuee3Q1IqGMRY_HNN59R {
  display: block;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.avec14KzholcSrZNzOYw {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  gap: var(--sl-space-0) !important;
}

.avec14KzholcSrZNzOYw > * {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.uxo1khomOXxb0qsExLDw {
  color: var(--sl-fg-base);
  font: var(--sl-text-emphasis-font);
}

.sISI1SQvy1K4fNsceA9M {
  color: var(--sl-fg-critical);
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
}

.ZFREP8Bz9cevEpp2rIl9 {
  margin-top: var(--sl-space-5);
}

.uHkW_r7oanr7IwYzQzqQ {
  padding: var(--sl-space-3);
  border-bottom: var(--sl-border-base);
  cursor: pointer;
  background: var(--sl-bg-base);
  box-sizing: border-box;
}

.uHkW_r7oanr7IwYzQzqQ:hover,
.UHZwFV5BOvDTn9HPU23U {
  background: var(--sl-bg-accent);
}

.uHkW_r7oanr7IwYzQzqQ:last-child {
  border-bottom: none;
}

.xgIHZZseCJFSQbNvxOY2 {
  width: 100%;
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-base);
  overflow: hidden;
}

.Q6TylUsUboVGFNqCkZzW {
  background: var(--sl-bg-base-soft);
  border-bottom: var(--sl-border-base);
  padding: var(--sl-space-3) var(--sl-space-4);
}

.XmhQn3Xs9BvYv6kC02ts {
  padding: var(--sl-space-4);
}

.D8XKa8uC8tK6gZsy1pwg {
  margin-top: var(--sl-space-1);
}

.c8Ss84EctV0_tpCwjkxJ {
  color: var(--sl-fg-accent);
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  min-width: auto;
}

.c8Ss84EctV0_tpCwjkxJ:hover:not(:disabled) {
  color: var(--sl-fg-accent-hover);
}

.c8Ss84EctV0_tpCwjkxJ:focus-visible {
  outline: none;
  box-shadow: var(--sl-focus-ring-accent);
  border-radius: var(--sl-radius-1);
}

.c8Ss84EctV0_tpCwjkxJ:disabled {
  color: var(--sl-fg-base-disabled);
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/LinkInsertionOrder/styles.module.css"],"names":[],"mappings":"AAAA;kEACkE;AAClE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,iCAAiC;EACjC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,oDAAoD;EACpD,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB","sourcesContent":["/* Block wrapper so Shoreline Field (inline-flex) fills the parent instead of\n   sizing to the hint/select intrinsic width via min-width:auto. */\n.field {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.fieldInner {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  gap: var(--sl-space-0) !important;\n}\n\n.fieldInner > * {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.label {\n  color: var(--sl-fg-base);\n  font: var(--sl-text-emphasis-font);\n}\n\n.required {\n  color: var(--sl-fg-critical);\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n}\n\n.description {\n  margin-top: var(--sl-space-5);\n}\n\n.option {\n  padding: var(--sl-space-3);\n  border-bottom: var(--sl-border-base);\n  cursor: pointer;\n  background: var(--sl-bg-base);\n  box-sizing: border-box;\n}\n\n.option:hover,\n.optionFocused {\n  background: var(--sl-bg-accent);\n}\n\n.option:last-child {\n  border-bottom: none;\n}\n\n.preview {\n  width: 100%;\n  border: var(--sl-border-base);\n  border-radius: var(--sl-radius-2);\n  background: var(--sl-bg-base);\n  overflow: hidden;\n}\n\n.previewHead {\n  background: var(--sl-bg-base-soft);\n  border-bottom: var(--sl-border-base);\n  padding: var(--sl-space-3) var(--sl-space-4);\n}\n\n.previewGrid {\n  padding: var(--sl-space-4);\n}\n\n.previewValue {\n  margin-top: var(--sl-space-1);\n}\n\n.change {\n  color: var(--sl-fg-accent);\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n  cursor: pointer;\n  border: none;\n  background: none;\n  padding: 0;\n  min-width: auto;\n}\n\n.change:hover:not(:disabled) {\n  color: var(--sl-fg-accent-hover);\n}\n\n.change:focus-visible {\n  outline: none;\n  box-shadow: var(--sl-focus-ring-accent);\n  border-radius: var(--sl-radius-1);\n}\n\n.change:disabled {\n  color: var(--sl-fg-base-disabled);\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": `vuee3Q1IqGMRY_HNN59R`,
	"fieldInner": `avec14KzholcSrZNzOYw`,
	"label": `uxo1khomOXxb0qsExLDw`,
	"required": `sISI1SQvy1K4fNsceA9M`,
	"description": `ZFREP8Bz9cevEpp2rIl9`,
	"option": `uHkW_r7oanr7IwYzQzqQ`,
	"optionFocused": `UHZwFV5BOvDTn9HPU23U`,
	"preview": `xgIHZZseCJFSQbNvxOY2`,
	"previewHead": `Q6TylUsUboVGFNqCkZzW`,
	"previewGrid": `XmhQn3Xs9BvYv6kC02ts`,
	"previewValue": `D8XKa8uC8tK6gZsy1pwg`,
	"change": `c8Ss84EctV0_tpCwjkxJ`
};
export default ___CSS_LOADER_EXPORT___;
